<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->

<span
    #tooltip
    [position]="placement"
    [relatedContainerRef]="container"
    [shouldHandleMouseEvents]="false"
    [tooltipTemplate]="tooltipTpl"
    suiTooltip
    class="content"
>
    <ng-content></ng-content>
</span>
<ng-template #tooltipTpl>
    @if (isEditModeActive) {
        <textarea [(ngModel)]="currentText"></textarea>
        <span>
            <button (click)="saveText()" windeActionIcon>
                <sui-svg-icon icon="save" windeGrey />
            </button>
            <button (click)="hideTooltip()" windeActionIcon>
                <sui-svg-icon icon="cross" windeGrey />
            </button>
        </span>
    } @else {
        <span style="white-space: pre-line">{{ currentText }}</span>
        @if (isFixed) {
            <span>
                <button (click)="startEdit()" windeActionIcon>
                    <sui-svg-icon icon="pencil" windeGrey />
                </button>
                <button (click)="hideTooltip()" windeActionIcon>
                    <sui-svg-icon icon="cross" windeGrey />
                </button>
            </span>
        }
    }
</ng-template>
